var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rank <= 3 && _vm.type === 'winner')?_c('b-badge',{staticClass:"d-flex align-items-center justify-content-center",style:({
    width: '28px',
    height: '28px',
    fontSize: '14px',
    background: _vm.badgeColor,
  }),attrs:{"pill":"","variant":_vm.badgeColor}},[_vm._v(" "+_vm._s(_vm.rank === 1 ? "🏆" : _vm.rank)+" ")]):_c('b-badge',{staticClass:"d-flex align-items-center justify-content-center",style:({ width: '28px', height: '28px', fontSize: '14px' }),attrs:{"pill":"","variant":_vm.type === 'winner' ? 'success' : 'danger'}},[_vm._v(" "+_vm._s(_vm.rank)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }